var exports = {
  "Ij": "SearchEnginesTab.module__customEngineRow___aXhYQX",
  "LW": "SearchEnginesTab.module__customEngineActions___aXhYQX",
  "r9": "SearchEnginesTab.module__editButton___aXhYQX",
  "DT": "SearchEnginesTab.module__removeButton___aXhYQX",
  "QE": "SearchEnginesTab.module__newEngineButtonContainer___aXhYQX",
  "gC": "SearchEnginesTab.module__noEnginesText___aXhYQX",
};

module.exports = exports;
